// extracted by mini-css-extract-plugin
export default {"overlay":"Loader_overlay__Q-1VX","loader":"Loader_loader__QXXr7","spin":"Loader_spin__hTnAM","text":"Loader_text__iTK6G"};